import ApiService from '@/services/core/api.service'

const BorrowingItemService = {
  async get (query = '') {
    return ApiService.get(`admin/borrowing-items?${query}`)
  },

  async show (id, query = '') {
    return ApiService.get(`admin/borrowing-items/${id}?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/borrowing-items', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/borrowing-items/${payload.id}`, payload)
  }
}

export default BorrowingItemService
